import styled from "styled-components"

export const MediaPlayer = styled.div`
  height: 500px;
  & .video-react-controls-enabled {
    height: 100%;
  }
  @media (max-width: 767.9px) {
    height: 450px;
  }
  @media (max-width: 639.9px) {
    height: 240px;
  }
`

export const ImageSpan2 = styled.div`
  height: ${({ height }) => (height == "true" ? "500px" : "326.54px")};

  @media (max-width: 767.9px) {
    height: ${({ height }) => (height == "true" ? "450px" : "326.54px")};
  }
`

export const Images5 = styled.div`
  height: calc(500px - 326.54px);
`

export const DescriptionWork = styled.div`
  & h2 {
    font-family: "Roboto";
    font-style: normal;
    font-weight: 500;
    font-size: 28px;
    color: #323232;
    line-height: 100%;
  }
  & p {
    font-family: "Roboto";
    font-style: normal;
    font-weight: 400;
    font-size: 17px;
    line-height: 160%;
    color: #323232;
  }
`

export const Views = styled.div`
  & h2 {
    font-family: "Roboto";
    font-style: normal;
    font-weight: 500;
    font-size: 28px;
    line-height: 100%;
    color: #000000;
  }
`
